export default __webpack_public_path__ + "static/media/logo.279691de.png";